/* De homepage (1-10-2026): een klik op een vriend opent het venster van De dieren van het strand, en een klik op een foto
   opent hem groter. Geen andere afhankelijkheden. */
(function () {
  'use strict';

  // Een vriend (Kaatje, Mup, Jeetje): het venster met spullen staat bij De dieren van het strand, als verborgen kaartje.
  document.addEventListener('click', function (e) {
    var vriend = e.target.closest('[data-kdv-vriend]');
    if (!vriend) return;
    var woord = vriend.getAttribute('data-kdv-vriend');
    var kaart = document.querySelector('.km-kaart[data-km-dier="' + woord.replace(/"/g, '') + '"]');
    if (kaart) kaart.click();
  });

  // Foto's groter bekijken: de twee bij Ik ben Carolien en de vier bij de voorstelling.
  var lb = null, img = null, lijst = [], nu = 0;
  function bouw() {
    lb = document.createElement('div');
    lb.className = 'kh-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="kh-lb__kader">' +
      '<button type="button" class="kh-lb__knop kh-lb__x" aria-label="Sluiten">×</button>' +
      '<button type="button" class="kh-lb__knop kh-lb__vor" aria-label="Vorige">‹</button>' +
      '<img class="kh-lb__img" alt="">' +
      '<button type="button" class="kh-lb__knop kh-lb__vol" aria-label="Volgende">›</button>' +
      '</div>';
    document.body.appendChild(lb);
    img = lb.querySelector('.kh-lb__img');
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.closest('.kh-lb__x')) sluit();
      else if (e.target.closest('.kh-lb__vor')) toon(nu - 1);
      else if (e.target.closest('.kh-lb__vol')) toon(nu + 1);
    });
  }
  function toon(n) {
    nu = (n + lijst.length) % lijst.length;
    var bron = lijst[nu];
    img.src = bron.currentSrc || bron.src;
    img.alt = bron.alt || '';
    lb.querySelector('.kh-lb__vor').hidden = lb.querySelector('.kh-lb__vol').hidden = lijst.length < 2;
  }
  function open(fotos, k) {
    if (!lb) bouw();
    lijst = fotos;
    toon(k);
    lb.classList.add('is-open');
    lb.querySelector('.kh-lb__x').focus();
  }
  function sluit() { if (lb) lb.classList.remove('is-open'); }
  document.addEventListener('keydown', function (e) {
    if (!lb || !lb.classList.contains('is-open')) return;
    if (e.key === 'Escape') sluit();
    if (e.key === 'ArrowLeft') toon(nu - 1);
    if (e.key === 'ArrowRight') toon(nu + 1);
  });

  document.addEventListener('click', function (e) {
    var groepen = ['[id$="iwt_ikbencarolien"] .km-iwt-kaart img', '[id$="km_gallery_voorstelling"] .km-gallery__image'];
    for (var g = 0; g < groepen.length; g++) {
      var fotos = Array.prototype.slice.call(document.querySelectorAll(groepen[g]));
      var k = fotos.indexOf(e.target.closest('img'));
      var kader = e.target.closest(g === 0 ? '.km-iwt-kaart' : '.km-gallery__media');
      if (k === -1 && kader) k = fotos.indexOf(kader.querySelector('img'));
      if (k > -1) { open(fotos, k); return; }
    }
  });
})();
